<ion-content>
  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button
        (click)="close()"
        fill="clear"
        color="dark"
        class="ion-no-padding"
      >
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>

      <ion-title
        class="ion-no-padding"
        *ngIf="dataServ.rData && dataServ.rData.dark_logo[0]"
      >
        <ion-img [src]="dataServ.rData.dark_logo"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">
    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1>
            <b>{{ "Notifications" | translate }}</b>
          </h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ng-container *ngIf="notifications.length > 0; else noNotifications">
      <ion-row class="notifications" *ngIf="authServ.isLogged">
        <ion-col size="12" *ngFor="let noti of notifications">
          <ion-item (click)="openNotification(noti)">
            <ion-icon slot="start" color="dark" name="mail-outline"></ion-icon>
            <ion-label>
              <ion-text color="dark" class="max-lines">
                <ng-container *ngIf="noti.title | caption | translate">
                  <b>{{ noti.title | caption | translate | sanitizeHtml }}</b> <br />
                </ng-container>
                <span *ngIf="noti.description | caption | sanitizeHtml">{{
                  noti.description | caption | sanitizeHtml
                }}</span>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ng-container>
    <ng-template #noNotifications>
      <ion-row class="message-row">
        <ion-col size="12">
          <ion-icon
            color="dark"
            class="close-icon"
            name="close-circle-outline"
          ></ion-icon>
          <ion-text class="message">
            <b> {{ "You don't have any notifications." | translate }}</b>
          </ion-text>
        </ion-col>
      </ion-row>
    </ng-template>
  </ion-grid>
</ion-content>
